// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@ces/Overrides/Widgets/Common/HeaderShipToAddress";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        display: inline-flex;
    `,
};

headerShipToAddressStyles.titleClickable = {
    css: css`
        display: inline-flex;
        align-items: center;
        gap: 8px;
    `,
};

headerShipToAddressStyles.titleIcon = {
    size: 14,
    color: "common.white",
};

headerShipToAddressStyles.titleTypography = {
    size: 12,
    lineHeight: "13px",
    weight: fontConfig.weight.bold,
    transform: "capitalize",
    ellipsis: true,
    color: "common.white",
};
